import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@cargomatic/ui';
import PDFViewer from '../../shipments/PDFViewer';
import { isPDF } from '../../../../utils/documents';

export function DocumentPreviewConfirmationModal({
  open,
  files,
  onRedo,
  onSave,
  onClose,
}) {
  const { t } = useTranslation();
  const [paginationContainer, setPaginationContainer] = useState(null);
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t('CONFIRM_DOCUMENT_VERIFICATION')}</DialogTitle>
        </DialogHeader>
        <div>
          {(files || []).map((file, index) => {
            if (isPDF(file.type)) {
              return (
                <div key={index}>
                  <PDFViewer
                    file={file.preview}
                    pdfStyle={{ maxWidth: '100%' }}
                    paginationContainer={paginationContainer}
                  />
                </div>
              );
            }
            return (
              <div key={index}>
                <img
                  className="w-full h-auto"
                  alt="Preview"
                  src={file.preview || ''}
                />
              </div>
            );
          })}
        </div>
        <DialogFooter className="sm:justify-between">
          <div ref={setPaginationContainer} className="flex flex-1" />
          <div className="flex gap-2">
            <Button variant="outline" onClick={onRedo}>
              {t('REDO')}
            </Button>
            <Button onClick={onSave}>{t('SAVE')}</Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

DocumentPreviewConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  files: PropTypes.array,
  onRedo: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
